import { Transform } from 'class-transformer';
import { IsEmail, IsNotEmpty, IsOptional, IsString, Matches, ValidateIf } from 'class-validator';
import { IsCap } from '../../validation/is-cap.decorator';
import { IsPartitaIva } from '../../validation/is-partita-iva.decorator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { PROVINCIA_REGEX } from '../../validation/provincia';

function uppercase({ value }: { value: unknown }): unknown {
  return typeof value === 'string' ? value.toUpperCase() : value;
}

/** A destination field was filled in, so the destination group (via/cap/citta) is required. */
function hasAnyDestinationField(o: CreateCustomerDto): boolean {
  return !!(o.destinationVia || o.destinationCap || o.destinationCitta || o.destinationProvincia);
}

export class CreateCustomerDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  @IsPartitaIva()
  vatNumber?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  codiceFiscale?: string;

  @IsString()
  @IsNotEmpty()
  addressVia!: string;

  @IsCap()
  addressCap!: string;

  @IsString()
  @IsNotEmpty()
  addressCitta!: string;

  @Transform(uppercase)
  @Matches(PROVINCIA_REGEX, { message: 'Provincia non valida' })
  addressProvincia!: string;

  @ValidateIf(hasAnyDestinationField)
  @IsString()
  @IsNotEmpty()
  destinationVia?: string;

  @ValidateIf(hasAnyDestinationField)
  @IsCap()
  destinationCap?: string;

  @ValidateIf(hasAnyDestinationField)
  @IsString()
  @IsNotEmpty()
  destinationCitta?: string;

  @ValidateIf(hasAnyDestinationField)
  @OptionalStringTransform()
  @Transform(uppercase)
  @Matches(PROVINCIA_REGEX, { message: 'Provincia non valida' })
  destinationProvincia?: string;

  @IsEmail()
  @IsOptional()
  @OptionalStringTransform()
  email?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  phone?: string;
}
